module.exports = __webpack_public_path__ + "img/notaire.7631a983.webp";